export default function AdminGate({ isAdmin, loading, children }) {
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-gray-500 dark:text-gray-400">
        Checking access…
      </div>
    );
  }
  if (!isAdmin) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center p-6 text-center">
        <h1 className="text-2xl font-semibold mb-2">Not authorised</h1>
        <p className="text-gray-600 dark:text-gray-400 max-w-md">
          You do not have Broadcast access yet. Ask Arran North to add you to Broadcast
          in the Systems users console.
        </p>
      </div>
    );
  }
  return children;
}
